import gsap from 'gsap';
import SplitText from 'gsap/SplitText';
import CustomEase from 'gsap/CustomEase';
import ScrollTrigger from 'gsap/ScrollTrigger';
import nestedLinesSplit from '../utils/NestedLinesSplit';

gsap.registerPlugin(SplitText);
gsap.registerPlugin(CustomEase);
gsap.registerPlugin(ScrollTrigger);



CustomEase.create("JJEase", "M0,0 C0.17,0.67 0.166,0.94 1,1")

function fadeIn({element = null, staggered = false, duration = 0.5, ease = 'none', stagger = 0.2, opacity = 1}) {

    if (!element) return;

    return gsap.to(element, {
        opacity: opacity,
        duration: duration,
        ease: ease,
        stagger: staggered ? stagger : 0
    })
}

function fadeInUp({element = null, staggered = false, duration = 1.25, ease = 'power4.out', stagger = 0.25}) {

    if (!element) return;

    return gsap.to(element, {
        y: 0,
        opacity: 1,
        duration: duration,
        ease: ease,
        stagger: staggered ? stagger : 0
    })
}

function imageReveal({element = null, duration = 1.25, ease = 'power4.inOut', stagger = 0.2}) {

    if (!element) return;

    return gsap.to(element, {
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: duration,
        ease: ease
    });
}

function textFadeReveal({element = null, duration = 0.5, stagger = 0.11, ease = 'none'}) {

    if (!element) return;

    const splitText = nestedLinesSplit(element, {
        type: 'chars,words,lines',
    });

    return {
        textRevealFrom: gsap.from(splitText.chars, {
            autoAlpha: 0,
            duration: duration,
            stagger: stagger,
            ease: ease
        }),
        splitText: splitText
    }
}

export { 
    fadeIn,
    fadeInUp, 
    imageReveal,
    textFadeReveal
}